import { EXPERT_PARTNER_PATHS, EXPERT_PARTNER_USER_GROUPS, } from './constants.js';
import { z } from 'zod';
export const ExpertPartnerGroupSchema = z.array(z.enum(EXPERT_PARTNER_USER_GROUPS));
export const DiscoverExpertsRouteBase = z.enum(EXPERT_PARTNER_PATHS);
//# sourceMappingURL=schema.js.map